import {
  Component,
  Directive,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { AccountCodeService } from '../../services/account-code.service';
import { CustomerInboxJobsService } from '../../services/customer-inbox-jobs.service';
import { InboxBackService } from '../../services/inbox-back.service';
import { InboxJobsService } from '../../services/inbox-jobs.service';
import { JobsService } from '../../services/job.service';
import { BBWTMessageService } from '../../services/message.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng';
import { OrganisationsService } from '../../services/organisations.service';
import { getCombinedParameters } from '../../utils/getCombinedParameters';
import { InputHelper } from '../../utils/input.helper';
import { Location } from '@angular/common';
import { tryParseInt } from '../../utils/tryParseInt';
import {
  IJobOrderPriceItem,
  IJobOrderPriceSummary,
  IJobOrderSummaryItem,
} from 'src/app/interfaces/job/job';
import { TransactionLinesService } from 'src/app/services/transaction-lines.service';
import { AdditionalChargeService } from '../../services';
import { ITransactionLines } from '../../interfaces/transaction-lines/transaction-lines';
import {
  MovementTransactionChargeDTO,
  ServiceFeeTypesDTO,
  TaskVehicleRegistrationDTO,
} from 'src/app/interfaces/price-details-options';

@Component({
  selector: 'price-details',
  templateUrl: './price-details.component.html',
  styleUrls: ['./price-details.component.scss'],
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class PriceDetailsComponent implements OnInit {
  isAddOrder: boolean = false;
  isAddJob: boolean = false;
  isAddJoborOrderDlg: boolean = false;
  price: any = { id: 0 };
  orderCodes: SelectItem[] = [];
  jobCodes: SelectItem[] = [];

  public organisationTypeId: number;

  public order: any;
  public orderId: number;
  public jobId: number;
  public orderNumbersSelectItem: SelectItem[] = [];
  public vehicleRegistrationsSelectItem: SelectItem[] = [];
  public transactionCategorySelectItems: SelectItem[] = [];
  public additionalChargeTypesSelectItem: SelectItem[] = [];
  public transactionCategoryItem: SelectItem;
  public movementTransactionChargesDTO: MovementTransactionChargeDTO[] = [];
  public vehicleRegistrationDTO: TaskVehicleRegistrationDTO[] = [];
  public serviceFeeTypesDTO: ServiceFeeTypesDTO[] = [];
  public defaultDescription: string = '';

  public isLoaded: boolean = false;
  public orderPrices: any[] = [];
  public jobPrices: any[] = [];
  public supplierPrices: ITransactionLines[] = [];
  public engSupplierPrices: any[] = [];
  public enginieusJobPrices: any[] = []; // transaction lines where the type are engineius
  public customerPrices: ITransactionLines[] = [];
  public enginieusOrderPrices: any[] = []; // trnasactiosn where engineius will recover the cost from a 3rd party
  public jobOrderPriceSummary: IJobOrderPriceSummary = {
    items: [],
    totalSupplierExpense: 0,
    totalEngineiusExpense: 0,
    totalCustomerRevenue: 0,
    totalEngineiusRevenue: 0,
  };
  public transactionTypeKeys: {};
  public engineiusKey: string = 'ENGINEIUS';
  public customerKey: string = 'CUSTOMER';
  public supplierKey: string = 'SUPPLIER';
  private additional_charge_text = 'Additional Charge';
  private service_fee_text = 'serviceFee';
  public requestCompleted: number = 0;
  public jobOrderPriceItems: IJobOrderPriceItem[] = [];
  public isUpdatingPriceDetails: boolean = false;
  public syncExpensesLoading: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private inboxjobsService: InboxJobsService,
    public messageService: BBWTMessageService,
    private orgService: OrganisationsService,
    private accountCodesService: AccountCodeService,
    private additionalChargeService: AdditionalChargeService,
    private jobService: JobsService,
    public inputHelper: InputHelper,
    private location: Location,
    private transactionLineService: TransactionLinesService,
  ) {
    // initialise this here, as default, however make a call on init to update with server values
    this.transactionTypeKeys = { CUSTOMER: 1, SUPPLIER: 2, ENGINEIUS: 3 };
  }

  ngOnInit() {
    this.orgService.getCurrentUserOrgTypeId().then((res) => (this.organisationTypeId = res));
    getCombinedParameters(this.activatedRoute).subscribe((params) => {
      this.orderId = tryParseInt(params['orderId']) as number;
      this.jobId = tryParseInt(params['jobId']) as number;
      const supplierId = params['supplierId'];
      const customerId = params['customerId'];

      if (supplierId) {
        this.accountCodesService.getForSupplier(supplierId).then((res) => {
          this.jobCodes.push({ value: null, label: 'Select code...' });
          res.forEach((x) => this.jobCodes.push({ value: x.code, label: x.name }));
        });
      }

      if (customerId) {
        this.accountCodesService.getForSupplier(customerId).then((res) => {
          this.orderCodes.push({ value: null, label: 'Select code...' });
          res.forEach((x) => this.orderCodes.push({ value: x.code, label: x.name }));
        });
      }
      this.getTransactionLines();
      this.getPriceDetailsOptions();
    });
  }

  getPriceDetailsOptions() {
    this.transactionLineService.getPriceDetailsOptions(this.jobId, this.orderId).then((res) => {
      this.orderNumbersSelectItem = [];
      this.transactionCategorySelectItems = [];
      this.vehicleRegistrationsSelectItem = [];
      this.additionalChargeTypesSelectItem = [];
      this.movementTransactionChargesDTO = [];

      this.orderNumbersSelectItem = res.orderIdNumbers.map((o) => ({
        label: o.orderNumber,
        value: o.id,
      }));

      if (res.orderIdNumbers.length > 1) {
        this.orderNumbersSelectItem.unshift({
          label: 'Select an order number',
          value: null,
        });
      }

      this.setupVehicleRegNumberSelectItems(res.taskVehicleRegistrations);

      this.additionalChargeTypesSelectItem = [
        {
          label: 'Select a transaction category',
          value: null,
        },
        ...res.serviceFeeTypes.map((serviceType) => ({
          value: this.service_fee_text + serviceType.id,
          label: serviceType.displayName,
        })),
        ...res.additionalChargeTypes.map((a) => ({
          value: a.id,
          label: a.chargeType,
        })),
      ];
      this.serviceFeeTypesDTO = res.serviceFeeTypes;
      this.movementTransactionChargesDTO = res.movementTransactionCharges;
      this.vehicleRegistrationDTO = res.taskVehicleRegistrations;

      if (this.orderNumbersSelectItem.length < 2) {
        this.transactionCategorySelectItems = this.getMovementTransactionCharges();
        this.defaultDescription = this.movementTransactionChargesDTO[0]?.message;
      }
    });
  }

  onTaskChange() {
    const hasTaskId = this.price.taskId && this.price.taskId !== 0;

    if (hasTaskId) {
      this.transactionCategorySelectItems = this.additionalChargeTypesSelectItem;
      this.price.description = '';
      this.transactionCategoryItem = null;
    } else {
      this.transactionCategorySelectItems = this.getMovementTransactionCharges();
      this.price.description = this.movementTransactionChargesDTO[0]?.message || '';
    }
  }

  onOrderChange() {
    if (!this.price.orderId) {
      this.price.description = '';
      return;
    }

    this.price.description = this.movementTransactionChargesDTO[0]?.message;
    const filteredVehicles = this.vehicleRegistrationDTO.filter(
      (x) => x.orderId == this.price.orderId,
    );
    this.setupVehicleRegNumberSelectItems(filteredVehicles);
    if (this.price.taskId && this.price.taskId !== 0) {
      this.transactionCategorySelectItems = this.additionalChargeTypesSelectItem;
    } else {
      this.transactionCategorySelectItems = this.getMovementTransactionCharges();
    }
  }

  private setupVehicleRegNumberSelectItems(taskVehicleReg: TaskVehicleRegistrationDTO[]) {
    this.vehicleRegistrationsSelectItem = [
      {
        label: 'Select a vehicle',
        value: null,
      },
      ...taskVehicleReg.map((t) => {
        return {
          label: t.vehicleRegistration,
          value: t.taskId,
        } as SelectItem;
      }),
    ];
  }

  onTransactionCategoryChange(selectedObject: any): void {
    const selectedValue = selectedObject?.value;
    if (!selectedValue) return;

    const isOrderMovement = this.price.taskId < 1;

    if (isOrderMovement) {
      const charge = this.movementTransactionChargesDTO.find((x) => x.id === selectedValue);
      if (charge?.message) {
        this.price.description = charge.message;
      }
      return;
    }

    const chargeType = this.additionalChargeTypesSelectItem.find((x) => x.value === selectedValue);

    if (!chargeType) {
      return;
    }

    const { value, label } = chargeType;

    if (typeof value !== 'number') {
      this.price.description = label;
    } else {
      this.price.description = `${this.additional_charge_text}: ${label}`;
    }
  }

  getTransactionLines() {
    this.transactionLineService
      .getTransactionTypes()
      .then((res) => {
        if (res && res.length > 0)
          this.transactionTypeKeys = res.reduce(
            (acc, curr) => ((acc[curr.name.toUpperCase()] = curr.id), acc),
            {},
          );
        this.load();
      })
      .catch((err) => {
        console.log(`Error loading transaction types: ${err}`);
        this.load();
      });
  }

  getMovementTransactionCharges(): SelectItem[] {
    return this.movementTransactionChargesDTO.map((m) => {
      return {
        label: m.transactionChargeName,
        value: m.id,
      } as SelectItem;
    });
  }

  showOrders() {
    return this.orderId != null;
  }

  showJobs() {
    return this.jobId != null && this.organisationTypeId != 2;
  }

  showEngineiusJobPrices = () =>
    this.engSupplierPrices && this.engSupplierPrices.length > 0 && this.organisationTypeId == 1;
  showEngineiusOrderPrices = () =>
    this.enginieusOrderPrices &&
    this.enginieusOrderPrices.length > 0 &&
    this.organisationTypeId == 1;

  load() {
    this.jobOrderPriceSummary.items = [];
    this.jobOrderPriceItems = [];
    this.requestCompleted = 0;
    if (this.showOrders()) {
      this.inboxjobsService.getOrderPriceDetails(this.orderId).then((res) => {
        this.orderPrices = res;
        this.requestCompleted++;
        this.setOrderSummary(res);
      });
    }
    if (this.showJobs()) {
      this.inboxjobsService.getJobPriceDetails(this.jobId).then((res) => {
        this.jobPrices = res;
        this.requestCompleted++;
        this.setJobSummary(res);
      });
    }
  }

  setJobSummary(items: ITransactionLines[]) {
    let result: IJobOrderPriceItem[] = [];
    if (items) {
      this.supplierPrices = items.filter(
        (t) =>
          t.transactionTypeId == null ||
          t.transactionTypeId == this.transactionTypeKeys[this.supplierKey],
      );
      this.engSupplierPrices = items.filter(
        (t) => t.transactionTypeId == this.transactionTypeKeys[this.engineiusKey],
      );
      for (let index = 0; index < items.length; index++) {
        const elem = items[index];
        let jobOrder: IJobOrderPriceItem = {
          createdDateTime: elem.createdDateTime,
          orderNumber: elem.order != null ? elem.order.orderNumber : null, // (elem.job != null && elem.job.orders != null ? elem.job.orders.reduce((concat, curr) => concat+="," +curr.orderNumber, "") : null),
          supplierName:
            elem.job != null ? (elem.job.supplier != null ? elem.job.supplier.name : null) : null,
          expense: elem.amount,
          description: elem.description,
          customerName: elem.order != null ? elem.order.customerName : null,
          revenue: null,
          transactionType:
            elem.transactionTypeId == this.transactionTypeKeys[this.engineiusKey]
              ? this.engineiusKey
              : this.supplierKey,
          vehicleReg:
            elem.task != null
              ? elem.task.vehicle != null
                ? elem.task.vehicle.registrationNumber
                : null
              : null,
          taskId: elem.taskId,
          jobNumber: elem.jobNumber,
        };
        result.push(jobOrder);
      }
      if (result && result.length > 0) {
        this.jobOrderPriceItems = this.jobOrderPriceItems.concat(result);
        this.generateSummaryReport();
      }
    }
  }

  setOrderSummary(items: ITransactionLines[]) {
    let result: IJobOrderPriceItem[] = [];
    if (items) {
      this.customerPrices = items.filter(
        (t) =>
          t.transactionTypeId == null ||
          t.transactionTypeId == this.transactionTypeKeys[this.customerKey],
      );
      this.enginieusOrderPrices = items.filter(
        (t) => t.transactionTypeId == this.transactionTypeKeys[this.engineiusKey],
      );
      for (let index = 0; index < items.length; index++) {
        const elem = items[index];
        let jobOrder: IJobOrderPriceItem = {
          createdDateTime: elem.createdDateTime,
          orderNumber: elem.orderNumber,
          customerName: elem.order != null ? elem.order.customerName : null,
          supplierName: null,
          revenue: elem.amount,
          description: elem.description,
          expense: null,
          transactionType:
            elem.transactionTypeId == this.transactionTypeKeys[this.engineiusKey]
              ? this.engineiusKey
              : this.customerKey,
          vehicleReg:
            elem.task != null
              ? elem.task.vehicle != null
                ? elem.task.vehicle.registrationNumber
                : null
              : null,
          taskId: elem.taskId,
          jobNumber: elem.jobNumber,
        };
        result.push(jobOrder);
      }
      if (result && result.length > 0) {
        this.jobOrderPriceItems = this.jobOrderPriceItems.concat(result);
        this.generateSummaryReport();
      }
    }
  }

  generateSummaryReport() {
    if (
      (this.requestCompleted == 2 && this.showJobs() && this.showOrders()) ||
      !this.showJobs() ||
      !this.showOrders()
    ) {
      let taskGroup;
      let allItems: IJobOrderSummaryItem[] = [];
      if (this.jobOrderPriceItems) {
        let items = this.jobOrderPriceItems;
        taskGroup = items.reduce((acc, curr) => {
          (acc[curr.taskId] = acc[curr.taskId] || []).push(curr);
          return acc;
        }, {});

        // separate the expense (with taskId) from other with movement income or expense (taskId)
        for (let x in taskGroup) {
          if (x === 'null' || x === 'undefined') {
            // for jobs or orders movement cost
            let jobOrderTLines = taskGroup[x];
            let orderGroup = jobOrderTLines.reduce((acc, curr) => {
              // bearing in mind the job TL's will not have an Order#
              (acc[curr.orderNumber] = acc[curr.orderNumber] || []).push(curr);
              return acc;
            }, {});

            if (orderGroup) {
              for (let y in orderGroup) allItems.push(this.getJobSummaryItem(orderGroup[y]));
            }
          } else {
            allItems.push(this.getJobSummaryItem(taskGroup[x]));
          }
        }
        this.jobOrderPriceSummary.items = allItems.sort(this.compareJobSummaryItems);
        this.jobOrderPriceSummary.totalSupplierExpense = this.jobOrderPriceSummary.items.reduce(
          (sum, current) => sum + current.supplierExpense,
          0,
        );
        this.jobOrderPriceSummary.totalCustomerRevenue = this.jobOrderPriceSummary.items.reduce(
          (sum, current) => sum + current.customerRevenue,
          0,
        );
        this.jobOrderPriceSummary.totalEngineiusExpense = this.jobOrderPriceSummary.items.reduce(
          (sum, current) => sum + current.engineiusExpense,
          0,
        );
        this.jobOrderPriceSummary.totalEngineiusRevenue = this.jobOrderPriceSummary.items.reduce(
          (sum, current) => sum + current.engineiusRevenue,
          0,
        );
        this.jobOrderPriceSummary.profitLoss =
          this.jobOrderPriceSummary.totalCustomerRevenue +
          this.jobOrderPriceSummary.totalEngineiusRevenue -
          (this.jobOrderPriceSummary.totalSupplierExpense +
            this.jobOrderPriceSummary.totalEngineiusExpense);
      }
    }
  }

  getJobSummaryItem(taskGroup: any[]): IJobOrderSummaryItem {
    return {
      orderNumber: taskGroup[0].orderNumber,
      vehicleReg: taskGroup[0].vehicleReg,
      customerRevenue: taskGroup.reduce((sum, curr) => {
        curr.transactionType == null || curr.transactionType == this.customerKey
          ? (sum += curr.revenue)
          : sum;
        return sum;
      }, 0),
      engineiusRevenue: taskGroup.reduce((sum, curr) => {
        curr.transactionType == this.engineiusKey ? (sum += curr.revenue) : sum;
        return sum;
      }, 0),
      supplierExpense: taskGroup.reduce((sum, curr) => {
        curr.transactionType == null || curr.transactionType == this.supplierKey
          ? (sum += curr.expense)
          : sum;
        return sum;
      }, 0),
      engineiusExpense: taskGroup.reduce((sum, curr) => {
        curr.transactionType == this.engineiusKey ? (sum += curr.expense) : sum;
        return sum;
      }, 0),
    };
  }

  addJob(transactionTypeId: number) {
    this.price = {
      id: 0,
      jobId: this.jobId,
      transactionTypeId: transactionTypeId,
      description: this.defaultDescription,
    };
    this.transactionCategorySelectItems = this.getMovementTransactionCharges();
    this.isAddOrder = false;
    this.isAddJob = true;
    this.isAddJoborOrderDlg = true;
  }

  addOrder(transactionTypeId: number) {
    this.price = {
      id: 0,
      orderId: this.orderId,
      transactionTypeId: transactionTypeId,
    };

    this.jobService.getPurchaseOrderNo(this.orderId).then((res) => {
      this.price.purchaseOrderNumber = res;
    });

    this.transactionCategorySelectItems = this.getMovementTransactionCharges();
    this.price.description = this.movementTransactionChargesDTO[0]?.message;
    this.isAddJob = false;
    this.isAddOrder = true;
    this.isAddJoborOrderDlg = true;
  }

  close() {
    this.isAddJob = false;
    this.isAddOrder = false;
    this.isAddJoborOrderDlg = false;
  }

  save(item) {
    item.amount = this.inputHelper.Dec2(item.amount);
    item.invoiceId =
      item.invoiceId == null &&
      item.transactionTypeId == this.transactionTypeKeys[this.engineiusKey]
        ? '-1'
        : item.invoiceId;
    this.isUpdatingPriceDetails = true;
    this.inboxjobsService
      .savePriceDetails(item)
      .then((x) => {
        this.load();
        this.close();
        this.isUpdatingPriceDetails = false;
      })
      .catch((err) => {
        this.isUpdatingPriceDetails = false;
      });
  }

  back() {
    this.location.back();
  }

  total(items: any[]) {
    var res = 0;
    items.forEach((x) => (res += x.amount));
    return this.inputHelper.Dec2(res);
  }
  modifyJobTransactionLine(transactionLineId) {
    this.price = this.jobPrices.find((t) => t.id == transactionLineId);
    if (this.price) {
      //remove any associated Job information to prevent this from being included in Supplier invoices as per TL rule
      this.price.orderNumber = null;
      this.price.orderId = null;
    }
    this.isAddJob = true;
    this.isAddJoborOrderDlg = true;
  }
  modifyOrderTransactionLine(transactionLineId) {
    this.price = this.orderPrices.find((t) => t.id == transactionLineId);
    if (this.price) {
      //remove any associated Job information to prevent this from being included in Supplier invoices as per TL rule
      this.price.jobNumber = null;
      this.price.jobId = null;
    }
    this.isAddOrder = true;
    this.isAddJoborOrderDlg = true;
  }
  canModifyOrderTransactionLine() {
    return this.organisationTypeId == 1;
  }
  canModifyJobTransactionLine() {
    return this.organisationTypeId == 1;
  }

  compareJobSummaryItems(x: IJobOrderSummaryItem, y: IJobOrderSummaryItem) {
    if (x.orderNumber == null || x.orderNumber < y.orderNumber) return -1;
    if (x.orderNumber > y.orderNumber) return 1;
    return 0;
  }

  async syncExpenses() {
    try {
      this.syncExpensesLoading = true;
      await this.additionalChargeService.syncExpenseTransactionLines(this.jobId);
      this.messageService.ShowSuccess('Success', 'Expense Transaction Lines Synced');
    } catch (err) {
      this.messageService.ShowError('Error', 'Expense Transaction Lines Sync Error');
    } finally {
      this.getTransactionLines();
      this.syncExpensesLoading = false;
    }
  }
}
